import Helpers from "../helpers";
import { TweenMax, Power3 } from "gsap";

export default class Gallery {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;

        this.sliderItems = this.element.querySelectorAll(".gallery__item");

        this.modal = this.element.querySelector(".gallery__modal");
        this.modalImg = this.element.querySelector(".gallery__modal-img");
        this.modalVideo = this.element.querySelector(".gallery__modal-video");

        this.close = this.element.querySelector(".gallery__modal-close");

        this.currentIndex = 0;
        this.sliderElement = this.element.querySelector(".gallery__slider");
        this.sliderLinks = this.element.querySelectorAll(
            ".gallery-slider__nav-link"
        );

        try {
            this.slides = this.element.querySelectorAll(".gallery__slide");
        } catch (error) {
            return;
        }

        this.init();
    }

    init() {
        this.bindEvents();

        this.setActiveSlide(true);
    }

    bindEvents() {
        window.addEventListener("resize", () => {
            let currentSlide = this.slides[this.currentIndex];
            TweenMax.set(this.sliderElement, {
                height: currentSlide.offsetHeight + "px"
            });
        });

        Helpers.forEach(this.sliderItems, (index, item) => {
            item.addEventListener("click", e => {
                e.preventDefault();

                let targetImg = e.currentTarget.querySelector(".gallery__img");
                let targetVideo = e.currentTarget.querySelector(
                    ".gallery__video"
                );

                if (targetImg && !targetVideo) {
                    this.modalImg.setAttribute(
                        "src",
                        targetImg.getAttribute("src")
                    );
                    //hide video and show img
                    this.modalImg.setAttribute(
                        "style",
                        "display:block; width:100%"
                    );
                    this.modalVideo.setAttribute("style", "display:none");

                    //modal activation
                    this.modal.classList.add("gallery__modal--active");
                } else if (targetImg && targetVideo) {
                    //hide img and show video
                    this.modalImg.setAttribute("style", "display:none");
                    this.modalVideo.setAttribute(
                        "src",
                        targetVideo.getAttribute("data-video")
                    );
                    this.modalVideo.setAttribute("style", "display:block");

                    //show modal
                    this.modal.classList.add("gallery__modal--active");
                }
            });
        });

        this.modal.addEventListener("click", e => {
            e.preventDefault();

            let target = e.target;
            let targetVideo = e.currentTarget.querySelector(
                ".gallery__modal-video"
            );

            if (target == this.modalImg) {
                return;
            }

            //Ak je video spustene a klikne a X tak zastav video
            if (targetVideo) {
                targetVideo.setAttribute("src", "");
            }

            this.modal.classList.remove("gallery__modal--active");
        });

        var gotoSlider = document.querySelector(".quarters__gotoWarehouse");
        if (gotoSlider) {
            gotoSlider.addEventListener("click", e => {
                this.currentIndex = 1;
                this.setActiveSlide();
            });
        }

        Helpers.forEach(this.sliderLinks, (index, item) => {
            item.addEventListener("click", event => {
                event.preventDefault();
                let el = event.currentTarget;
                const elementIndex = [...el.parentElement.children].indexOf(el);

                if (this.currentIndex === index) return;
                this.currentIndex = index;

                this.setActiveSlide();
            });
        });
    }

    animSlideOut(element, duration = 0.8) {
        TweenMax.to(element, duration, {
            x: -10,
            autoAlpha: 0,
            ease: Power3.easeInOut
        });
    }

    animSlideIn(element, duration = 0.8) {
        TweenMax.set(element, { x: 10 });
        TweenMax.to(element, duration, {
            x: 0,
            autoAlpha: 1,
            ease: Power3.easeInOut
        });
        TweenMax.to(this.sliderElement, duration, {
            height: element.offsetHeight + "px",
            ease: Power3.easeInOut
        });
    }

    setActiveSlide(force = false) {
        Helpers.forEach(
            this.slides,
            (index, item) => {
                // this.getMainSliderHeight();
                if (force) {
                    this.currentIndex === index
                        ? this.animSlideIn(item, 0)
                        : this.animSlideOut(item, 0);
                } else {
                    this.currentIndex === index
                        ? this.animSlideIn(item)
                        : this.animSlideOut(item);
                }
            },
            null
        );

        Helpers.forEach(this.sliderLinks, (index, item) => {
            if (item.classList.contains("berlin--blue")) {
                this.currentIndex === index
                    ? item.classList.add(
                          "gallery-slider__nav-link--active-berlin"
                      )
                    : item.classList.remove(
                          "gallery-slider__nav-link--active-berlin"
                      );
            } else {
                this.currentIndex === index
                    ? item.classList.add("gallery-slider__nav-link--active")
                    : item.classList.remove("gallery-slider__nav-link--active");
            }
        });
    }
}
